(function () {
    'use strict';

    angular.module("imApp").factory("activityGridService", ['$ihttp', function ($ihttp) {
        let service = {
            getActivityGrid: function (parms) {
                return $ihttp.post({
                    method: 2451,
                    parameters: parms || {}
                });
            },
            listOks: function (parms) {
                return $ihttp.post({
                    method: 1418,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
